import { resolveComponent as y, openBlock as o, createElementBlock as i, normalizeClass as c, normalizeStyle as h, createElementVNode as a, createVNode as m, renderSlot as p, toDisplayString as l, createCommentVNode as r, Transition as g, withCtx as _, withDirectives as x, createTextVNode as w, vShow as b } from "vue";
import { _ as v } from "../_plugin-vue_export-helper-dad06003.js";
const S = {
  name: "rNotice",
  props: {
    /**
     * 宽度：支持数字、百分比、带单位的值
     */
    width: {
      type: [Number, String],
      default: "100%"
    },
    /**
     * 主题类型：default | success | warning | error
     */
    type: {
      type: String,
      default: "default"
    },
    /**
     * 标题
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * 提示消息
     */
    message: {
      type: String,
      default: ""
    },
    /**
     * 展开信息
     */
    expand: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      open: !1
    };
  },
  computed: {
    noticeIcon() {
      switch (this.type) {
        case "success":
          return "icon-checkbox_on-large";
        case "default":
          return "icon-xinxi";
        case "warning":
          return "icon-info";
        case "error":
          return "icon-close-large";
      }
    },
    buttonStateIcon() {
      return this.open ? "el-icon-arrow-up" : "el-icon-arrow-down";
    },
    showToggle() {
      return this.expand || !!(this.$slots.expand && this.$slots.expand());
    },
    widthStyle() {
      const e = this.width;
      return isNaN(Number(e)) ? { width: e } : { width: `${e}px` };
    }
  }
}, N = { class: "r-notice-body--text" }, k = {
  key: 0,
  class: "r-notice-body--text-title"
}, C = {
  key: 1,
  class: "r-notice-body--text-message"
}, T = {
  key: 0,
  class: "r-notice-expand"
};
function I(e, u, t, V, s, n) {
  const f = y("r-icon");
  return o(), i(
    "div",
    {
      class: c(["r-notice", `r-notice-${t.type}`]),
      style: h(n.widthStyle)
    },
    [
      a(
        "div",
        {
          class: c(["r-notice-body", { "r-notice-body--expand": s.open }])
        },
        [
          m(f, {
            class: "r-notice-body--icon",
            name: n.noticeIcon
          }, null, 8, ["name"]),
          a("div", N, [
            p(e.$slots, "default", {}, () => [
              t.title ? (o(), i(
                "p",
                k,
                l(t.title),
                1
                /* TEXT */
              )) : r("v-if", !0),
              t.message ? (o(), i(
                "p",
                C,
                l(t.message),
                1
                /* TEXT */
              )) : r("v-if", !0)
            ])
          ]),
          n.showToggle ? (o(), i("button", {
            key: 0,
            type: "button",
            class: "r-notice-body--toggle",
            onClick: u[0] || (u[0] = (D) => s.open = !s.open)
          }, [
            a(
              "i",
              {
                class: c(n.buttonStateIcon)
              },
              null,
              2
              /* CLASS */
            )
          ])) : r("v-if", !0)
        ],
        2
        /* CLASS */
      ),
      m(g, { name: "slide" }, {
        default: _(() => [
          n.showToggle ? x((o(), i(
            "div",
            T,
            [
              p(e.$slots, "expand", {}, () => [
                w(
                  l(t.expand),
                  1
                  /* TEXT */
                )
              ])
            ],
            512
            /* NEED_PATCH */
          )), [
            [b, s.open]
          ]) : r("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ],
    6
    /* CLASS, STYLE */
  );
}
const d = /* @__PURE__ */ v(S, [["render", I], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/notice/notice.vue"]]);
d.install = function(e) {
  e.component(d.name, d);
};
export {
  d as default
};
